import { createSlice } from '@reduxjs/toolkit'
import { AppI } from '../schema';

const appInitState:AppI = {
    locale: 'es',
    lang: 'es',
    country: 'mx',
}

export const appSlice = createSlice({
    name: 'APP',
    initialState: appInitState,
    reducers: {
        setLocale: (state, { payload }) => {
            state.locale = payload
        },
        setLang: (state, { payload }) => {
            state.lang = payload;
        },
        setCountry: (state, { payload }) => {
            state.country = payload;
        },
        // Reset country to default if missing
        initializeApp: (state) => {
            if (!state.country) {
                state.country = 'mx';
            }
        }
    },
});

export const { setLocale, setLang, setCountry, initializeApp } = appSlice.actions;
